import * as React from 'react';
import './styles-blocker.scss';
import { BlockerApp } from './components/BlockerApp';
import { onLoad } from './init';

window.onload = () => onLoad(<BlockerApp />);
